import { render, staticRenderFns } from "./OrganisationModeration.vue?vue&type=template&id=e7b0fbfc&scoped=true"
import script from "./OrganisationModeration.vue?vue&type=script&lang=js"
export * from "./OrganisationModeration.vue?vue&type=script&lang=js"
import style0 from "./OrganisationModeration.vue?vue&type=style&index=0&id=e7b0fbfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b0fbfc",
  null
  
)

export default component.exports